import { c as _c } from "react/compiler-runtime";
import { getStarVariants, TrustpilotStar } from "@/components/custom/ProductBuilder/TrustpilotStar";
interface Props {
  rating: number;
  ratingLabel: string;
}
export default function TrustpilotServiceRating(t0) {
  const $ = _c(19);
  const {
    rating,
    ratingLabel
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== rating) {
    const starVariants = getStarVariants(rating, 5);
    t3 = "https://www.trustpilot.com/review/stickergiant.com";
    t4 = "_blank";
    t5 = "noopener noreferrer";
    t6 = "flex items-center gap-2 py-6 no-underline! hover:opacity-100!";
    t1 = "flex items-center gap-0.5";
    t2 = starVariants.map(_temp);
    $[0] = rating;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t1 || $[8] !== t2) {
    t7 = <div className={t1}>{t2}</div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== ratingLabel) {
    t8 = <span className="text-xs leading-none font-bold text-base-foreground">{ratingLabel}</span>;
    $[10] = ratingLabel;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t3 || $[13] !== t4 || $[14] !== t5 || $[15] !== t6 || $[16] !== t7 || $[17] !== t8) {
    t9 = <a href={t3} target={t4} rel={t5} className={t6}>{t7}{t8}</a>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
}
function _temp(variant, i) {
  return <TrustpilotStar key={`service-star-${i}-${variant}`} variant={variant} />;
}